import { useState } from 'react';
import { checklistData } from '../data/lessonsData';

function PracticalChecklist() {
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});

  const handleToggle = (categoryIndex: number, itemIndex: number) => {
    const key = `${categoryIndex}-${itemIndex}`;
    setCheckedItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const totalItems = checklistData.categories.reduce((sum, cat) => sum + cat.items.length, 0);
  const checkedCount = Object.values(checkedItems).filter(Boolean).length;
  const progress = Math.round((checkedCount / totalItems) * 100);

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-8">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-[#39FF14] rounded-full mb-4">
          <i className="ri-checkbox-line text-3xl text-[#1A3A2E]"></i>
        </div>
        <h1 className="text-3xl font-bold text-[#1A3A2E] mb-4">Checklist Práctico</h1>
        <p className="text-gray-600 max-w-2xl mx-auto mb-6">
          Verifica tu comprensión y aplicación de los conceptos del módulo. Marca cada ítem a medida que lo domines.
        </p>

        <div className="max-w-md mx-auto">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-semibold text-[#1A3A2E]">Progreso</span>
            <span className="text-sm font-bold text-[#39FF14]">{checkedCount}/{totalItems} ({progress}%)</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-[#39FF14] to-[#2de00f] transition-all duration-500 rounded-full"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      </div>

      <div className="space-y-8">
        {checklistData.categories.map((category, categoryIndex) => (
          <div key={categoryIndex} className="bg-gray-50 rounded-xl p-6">
            <h2 className="text-xl font-bold text-[#1A3A2E] mb-4 flex items-center gap-2">
              <i className="ri-folder-line text-[#39FF14]"></i>
              {category.title}
            </h2>
            <div className="space-y-3">
              {category.items.map((item, itemIndex) => {
                const key = `${categoryIndex}-${itemIndex}`;
                const isChecked = checkedItems[key] || false;

                return (
                  <label
                    key={itemIndex}
                    className="flex items-start gap-3 p-4 bg-white rounded-lg border border-gray-200 hover:border-[#39FF14] transition-colors cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={() => handleToggle(categoryIndex, itemIndex)}
                      className="mt-1 w-5 h-5 text-[#39FF14] border-gray-300 rounded focus:ring-[#39FF14] cursor-pointer"
                    />
                    <span className={`text-sm flex-1 transition-all ${
                      isChecked ? 'text-gray-400 line-through' : 'text-gray-700'
                    }`}>
                      {item}
                    </span>
                  </label>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {progress === 100 && (
        <div className="mt-8 bg-gradient-to-r from-[#1A3A2E] to-[#0F2419] rounded-xl p-6 text-center">
          <i className="ri-trophy-line text-5xl text-[#39FF14] mb-3"></i>
          <h3 className="text-2xl font-bold text-white mb-2">¡Checklist Completado!</h3>
          <p className="text-gray-300">
            Has verificado todos los puntos del módulo. Ahora realiza la autoevaluación para consolidar tu aprendizaje.
          </p>
        </div>
      )}
    </div>
  );
}

export default PracticalChecklist;